function applyQuotes() {
    const blockquotes = document.querySelectorAll('.cmp-quote__quote')
  
    blockquotes.forEach(blockquote => {
      const paragraphs = Array.from(blockquote.querySelectorAll('p'))
      const nonEmptyParas = paragraphs.filter(p => p.textContent.trim().length > 0)
  
      if (nonEmptyParas.length > 0) {
        const first = nonEmptyParas[0]
        const last = nonEmptyParas[nonEmptyParas.length - 1]
  
        if (!first.textContent.trim().startsWith('“')) {
          first.insertAdjacentText('afterbegin', '“')
        }
  
        if (!last.textContent.trim().endsWith('”')) {
          last.insertAdjacentText('beforeend', '”')
        }
      }
    })
  }
  
  document.addEventListener('DOMContentLoaded', applyQuotes)
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        applyQuotes()
      }
    })
  })
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
  